import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { captureCampaignFromUrl } from "utils/campaignAttribution";

/**
 * Captures marketing ?ref= / UTM params on any public page (not only signup),
 * so homepage or career-portal landings still attribute correctly.
 */
export const CampaignCapture = () => {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (
      params.get("ref") ||
      params.get("campaign_ref") ||
      params.get("campaign")
    ) {
      captureCampaignFromUrl(location.search);
    }
  }, [location.search]);

  return null;
};
